import React, { useEffect, useMemo, useState } from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { createAppTheme } from './index';
import { applyColorMode, getColorMode } from './colorMode';

export const ColorModeContext = React.createContext({
  mode: 'light',
  toggleColorMode: () => {},
});

export const useColorMode = () => React.useContext(ColorModeContext);

export const ColorModeProvider = ({ children }) => {
  const [mode, setMode] = useState(getColorMode);

  useEffect(() => {
    applyColorMode(mode);
  }, [mode]);

  const theme = useMemo(() => createAppTheme(mode), [mode]);
  const value = useMemo(() => ({
    mode,
    toggleColorMode: () => setMode((current) => (current === 'dark' ? 'light' : 'dark')),
  }), [mode]);

  return (
    <ColorModeContext.Provider value={value}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default ColorModeProvider;
